import { normalizeLookupItem } from '@utils/storeDataNormalization';
import factory from '@helpers/storeFactories/factory';
import { apiServicePriceRules } from '@api';
import storeConstants from '@/utils/constants/store';

const STORE_NAME = 'hotelRulesLookup';

const store = factory.createStore(
    STORE_NAME,
    {
        get: apiServicePriceRules.priceRules.hotel.getLookup,
    },
    {
        actionsOptions: {
            get: {
                refresh: false,
                offset: 0,
                limit: 99,
            },
            controlItems: storeConstants.ACTION_GET_CONTROL_ITEMS.ALL,
        },
        normalizeItemFn: normalizeLookupItem,
    }
);

export default store;
